import type { HostAdapter } from "./adapter";

type ThemeMode = "light" | "dark";

/**
 * Telegram's `setHeaderColor` / `setBottomBarColor` only accept `#rrggbb`, so
 * the two host-facing surfaces need literal sRGB twins of their CSS tokens.
 *
 * header  = surface.telegram.header  = surface.canvas
 * bottom  = surface.telegram.bottomBar = surface.raised
 *
 * `host.theme.test.ts` re-derives these from the values in
 * tokens.semantic.css, so the pair cannot drift apart unnoticed.
 */
export const HOST_SURFACE_HEX = {
  light: { header: "#f4f4f1", bottomBar: "#ffffff" },
  dark: { header: "#0e0f10", bottomBar: "#1a1c1e" },
} as const satisfies Record<ThemeMode, { header: string; bottomBar: string }>;

/** Mirrors public/theme-boot.js, which runs the same logic before React mounts. */
export function applyTheme(mode: ThemeMode): void {
  document.documentElement.dataset.theme = mode;
}

export function syncHostChrome(host: HostAdapter, mode: ThemeMode): void {
  const surfaces = HOST_SURFACE_HEX[mode];
  host.setHeaderColor(surfaces.header);
  host.setBottomBarColor(surfaces.bottomBar);
}
